import { Typography, type TypographyProps } from '@mui/material';
import { forwardRef } from 'react';

/**
 * @tier atom
 *
 * Renders text in a theme-driven variant. Always use this — never raw
 * `<p>`, `<span>`, or `<h*>` with inline styling — so font, weight,
 * size, line-height, and color all flow from the theme.
 *
 * Variants used by the AI Agents page:
 *   - `h3`           — page title ("Try Vayu agents")
 *   - `body1`        — page description / subtitle
 *   - `body1Medium`  — card titles ("Insights agent")
 *   - `caption`      — card description, card status
 *
 * Pick color via the `color` prop using palette keys
 * (e.g. `color="text.primary"`, `color="text.secondary"`,
 * `color="text.disabled"`) — never a hex literal.
 */
export type VyTypographyProps = TypographyProps;

export const VyTypography = forwardRef<HTMLElement, VyTypographyProps>(
  function VyTypography(props, ref) {
    return <Typography ref={ref} {...props} />;
  },
);
